import { createFeatureSelector, createSelector } from "@ngrx/store";
import { InterfaceState } from "./interface.state";

export const selectInterfaceState =
  createFeatureSelector<InterfaceState>("interface");

export const selectActiveNewModal = createSelector(
  selectInterfaceState,
  (state: InterfaceState) => state.activeNewModal,
);

export const selectFileUploadStatuss = createSelector(
  selectInterfaceState,
  (state: InterfaceState) => state.fileUploadStatuss,
);

export const selectContextMenuIsOpen = createSelector(
    selectInterfaceState,
    (state: InterfaceState) => state.contextMenuOpen
)
